import amplifyOutputs from '/amplify_outputs.json' with { type: 'json' };
import '@styles/main.scss';
import './class-registration.css';

// ********* Add Top Nav & Footer *************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// Import our organized registration form components from the renamed aggregator file
import {
  initPayment,
  initStudentInfo,
  initStudentSchools,
  initParentInfo,
  initEmergContact,
  initMedicalInfo,
  initFormVal,
   initPhoneFormatters,
  initConsentSubmit
} from './modules/modulesIndex';

// Loading Spinner Lifecycle Block
window.addEventListener('DOMContentLoaded', () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.display = "block";
    window.addEventListener('load', () => {
      setTimeout(() => {
        preloader.style.transition = "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
        preloader.style.opacity = "0";
        setTimeout(() => { preloader.remove(); }, 300);
      }, 600);
    });
  }
});

// Primary Initialization Trigger Loop
document.addEventListener('DOMContentLoaded', async () => {

  // Sets up third-party services and variables first
  await initPayment();
  
  // Fires off all section modules, setting up form behaviors at once
  initStudentInfo();
  initStudentSchools();
  initParentInfo();
  initEmergContact();
  initMedicalInfo();
  initFormVal();

  initPhoneFormatters(); 

    // Check the browser's current address parameters
  const urlParams = new URLSearchParams(window.location.search);
  const registrationSuccess = urlParams.has('session_id');
  const registrationCanceled = urlParams.get('status') === 'canceled';

  // Pass the success status directly into your submission module layout controller
  initConsentSubmit(registrationSuccess, registrationCanceled);
});